import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
import React from "react";
import { SectionHeader } from "./header";
type Props = {
  eyebrow?: React.ReactNode;
  headline?: string;
  text?: string;
  link?: React.ReactNode;
  hasHeaderData: boolean;
  children: [React.ReactNode, React.ReactNode];
};
export function Pair({
  eyebrow,
  headline,
  text,
  link,
  hasHeaderData,
  children
}: Props) {
  const [item1, item2] = children;
  return <_StyledDiv $_css={[{
    "display": "none",
    "@media (min-width: 1024px)": {
      "display": "block",
      "paddingLeft": "var(--spacing-xl)",
      "paddingRight": "var(--spacing-xl)",
      "paddingTop": "var(--spacing-2xl)",
      "paddingBottom": "var(--spacing-2xl)"
    }
  }]}>
      <_StyledDiv2 $_css2={[{
      "display": "flex",
      "gap": "var(--spacing-md)",
      "overflow": "hidden"
    }]}>
        {hasHeaderData && <_StyledDiv3 $_css3={[{
        "display": "flex",
        "width": "100%",
        "flexBasis": "33.333333%",
        "flexDirection": "column",
        "justifyContent": "space-between",
        "padding": "var(--spacing-xl)"
      }]}>
            <SectionHeader alignment="vertical" eyebrow={eyebrow} headline={headline} text={text} link={link} />
          </_StyledDiv3>}
        <_StyledDiv4 $_css4={[{
        "width": "100%"
      }, hasHeaderData ? {
        "flexBasis": "33.333333%"
      } : {
        "flexBasis": "50%"
      }]}>{item1}</_StyledDiv4>
        <_StyledDiv5 $_css5={[{
        "width": "100%"
      }, hasHeaderData ? {
        "flexBasis": "33.333333%"
      } : {
        "flexBasis": "50%"
      }]}>{item2}</_StyledDiv5>
      </_StyledDiv2>
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-1tuxf54-0"
})`${p => p.$_css}`;
var _StyledDiv2 = _styled2("div").withConfig({
  componentId: "sc-sf-1tuxf54-1"
})`${p => p.$_css2}`;
var _StyledDiv3 = _styled3("div").withConfig({
  componentId: "sc-sf-1tuxf54-2"
})`${p => p.$_css3}`;
var _StyledDiv4 = _styled4("div").withConfig({
  componentId: "sc-sf-1tuxf54-3"
})`${p => p.$_css4}`;
var _StyledDiv5 = /*#__PURE__*/_styled5("div").withConfig({
  displayName: "pair___StyledDiv5",
  componentId: "sc-1476wq-0"
})(["", ""], p => p.$_css5);